import React from 'react'
//import Signup from './Form/Patient/Signup'
import {  SubTitle,  Info,  FormContainer,  LoginBtn,  TitleContainer,  TabPanel,  LogoImage,} from './Registration.styles'
import { useState } from 'react'
import { Box, InputAdornment,  IconButton,  TextField,  Container,  MenuItem,  Tabs,  Tab,  Typography,  Button,  Link} from '@mui/material'
import VitalSignsModel from './Model/VitalSignsModel';
import { createPatientsVitalSignsPublic } from '../../services/patients'
import { useToasts } from 'react-toast-notifications'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom'; 

const GetPatientNumber = ({ user, loginWithRedirect }) => {
//const [vitalSigns,setVitalSigns] = useState(VitalSignsModel);
//const [collectionDate, setCollectionDate] = useState(dayjs());
//const	[email, setEmail] = useState('');
const { addToast } = useToasts();
const history = useHistory();

// const	valueChangeHandler = (e) => {
// 	const { name, value } = e.target;
//     	setVitalSigns(prev => ({
//       		...prev,      // Spread previous state
//       		[name]: parseInt(value) // Update only the changed field		
// 		}));
// }
// const	valueChangeHandlerText = (e) => {
// 	const { name, value } = e.target;
//     	setVitalSigns(prev => ({
//       		...prev,      // Spread previous state
//       		[name]: value // Update only the changed field		
// 		}));
// }
// 	
// const submitHandler = () => { 
// 	console.log('submitting the data - ' + JSON.stringify(vitalSigns));
// 	try
// 	{
// 		vitalSigns.createUser = vitalSigns.ehxPatientId;
// 		vitalSigns.createDate = new Date(collectionDate);
// 		const results = createPatientsVitalSignsPublic(vitalSigns);
//       	const message = 'Thank you, your data has been added.';
//    		addToast(message, {
//         	autoDismiss: true,
//         	appearance: 'success',
//       	})
// //       	history.push('/');
// 	}
// 	catch(err)
// 	{
//       	const message = err;
//    		addToast(message, {
//         	autoDismiss: true,
//         	appearance: 'error',
//       	})
// 	}			
// }
	
  return (
  <>
    <Container>
      <Info>
        <TitleContainer>
          <SubTitle>
        	<LogoImage />
            <br />
            Become the best version of you! Already
            have an account? &nbsp; &nbsp;
            <span>
              <LoginBtn onClick={() => loginWithRedirect()}>Login here</LoginBtn>
            </span>
            <br />
          </SubTitle>
        </TitleContainer>
      </Info>
      <br />
      <div>
      <h4>How to get your patient number</h4>
      <h5>1. Log into your account</h5>
      <h5>2. At the top left corner of your screen click on your name. If using a mobile device, click the icon with 3 lines next to the logo in the header of the page to open the menu.</h5>
      <h5>3. At the top of your user profile page your patient number is displayed as the ID Number field.</h5>
      <h5>4. If you are still having difficulty, please send a request to support@hdptc.org and include your patient name, phone number and email to request for your ID Number to be sent to you</h5>
      </div>

      <hr />
      <Link href="/vital-signs">
      	<Button 
      		variant="outlined"
      		color="success"
      	>
      		Vital Signs
      	</Button>
      </Link>
      &nbsp;
      <Link href="/register-patient">
      	<Button 
      		variant="outlined"
      		color="info"
      	>
      		register
      	</Button>
      </Link>
      &nbsp;
      <Link href="/">
      	<Button 
      		variant="outlined"
      		color="warning"
      	>
      		Login
      	</Button>
      </Link>
    </Container>
    </>
  )
}


export default GetPatientNumber

